// removed by extract-text-webpack-plugin
module.exports = {"container":"_3ESXnJsMhfUXUhLqC9he9P"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Settings/Signature/Sign/styles.css
// module id = 2559
// module chunks = 0